import {
  ProximityApiFactory,
  Proximity,
  JrProximity,
  ProximityPriorDiscussionSchedule,
  ProximityWitnessSchedule,
} from '@/api'
import { BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 近接工事申請登録(申請者)
 */
export class ApplicantCreateRequest extends BaseUserActionRequest {
  private proximity: Proximity
  constructor(proximity: Proximity) {
    super()
    this.proximity = proximity
  }

  protected request(): AxiosPromise<Proximity> {
    const api = ProximityApiFactory()
    return api.proximityApplicantCreate(this.proximity)
  }
}

/**
 * 近接工事申請件名詳細編集(新規登録)
 */
export class ProximityCreate extends BaseUserActionRequest {
  private proximity: JrProximity
  constructor(proximity: JrProximity) {
    super()
    this.proximity = proximity
  }

  protected request(): AxiosPromise<JrProximity> {
    const api = ProximityApiFactory()
    return api.proximityCreate(this.proximity)
  }
}

/**
 * 近接工事申請件名詳細編集(編集)
 */
export class ProximityUpdate extends BaseUserActionRequest {
  private proximity: JrProximity
  private proximityId: number
  constructor(proximityId: number, proximity: JrProximity) {
    super()
    this.proximityId = proximityId
    this.proximity = proximity
  }

  protected request(): AxiosPromise<JrProximity> {
    const api = ProximityApiFactory()
    return api.proximityUpdate(this.proximityId, this.proximity)
  }
}

/**
 * 近接工事 事前協議日程保存
 */
export class PriorDiscussionScheduleUpdate extends BaseUserActionRequest {
  private proximityId: number
  private data: ProximityPriorDiscussionSchedule
  constructor(proximityId: number, dateTime: string) {
    super()
    this.proximityId = proximityId
    this.data = {
      prior_discussion_schedule_time: dateTime,
    }
  }

  protected request(): AxiosPromise<ProximityPriorDiscussionSchedule> {
    const api = ProximityApiFactory()
    return api.proximityPriorDiscussionPriorDiscussionSchedule(this.proximityId, this.data)
  }
}

/**
 * 近接工事 現地立会日程保存
 */
export class WitnessScheduleUpdate extends BaseUserActionRequest {
  private proximityId: number
  private data: ProximityWitnessSchedule
  constructor(proximityId: number, dateTime: string) {
    super()
    this.proximityId = proximityId
    this.data = {
      witness_schedule_time: dateTime,
    }
  }

  protected request(): AxiosPromise<ProximityWitnessSchedule> {
    const api = ProximityApiFactory()
    return api.proximityWitnessWitnessSchedule(this.proximityId, this.data)
  }
}
